export enum AuthType {
    ApiKey = 'API_KEY',
    IAM_Token = 'IAM_TOKEN'
}
